import { useState, useCallback } from 'react';
import { QuizData } from '../services/types';
import apiClient from '../services/api';

export const useQuizHistory = () => {
  const [selectedQuizId, setSelectedQuizId] = useState<string | null>(null);
  const [isLoadingRetake, setIsLoadingRetake] = useState(false);
  const [retakeQuizData, setRetakeQuizData] = useState<QuizData | null>(null);
  const [historyError, setHistoryError] = useState<string | null>(null);

  const selectQuizForResults = useCallback((quizId: string) => {
    setSelectedQuizId(quizId);
    setHistoryError(null);
  }, []);

  const loadQuizForRetake = useCallback(async (quizId: string, setQuizData?: (data: QuizData) => void) => {
    try {
      setIsLoadingRetake(true);
      setHistoryError(null);
      const response = await apiClient.getQuizForRetake(quizId);
      setRetakeQuizData(response.quiz_data);
      if (setQuizData) {
        setQuizData(response.quiz_data);
      }
      return response.quiz_data;
    } catch (error) {
      const errorMessage = error instanceof Error ? error.message : 'Failed to load quiz for retake';
      setHistoryError(errorMessage);
      throw new Error(errorMessage);
    } finally {
      setIsLoadingRetake(false);
    }
  }, []);

  const clearQuizHistory = useCallback(() => {
    setSelectedQuizId(null);
    setRetakeQuizData(null);
    setHistoryError(null);
  }, []);

  return {
    selectedQuizId,
    retakeQuizData,
    isLoadingRetake,
    historyError,
    selectQuizForResults,
    loadQuizForRetake,
    clearQuizHistory,
  };
};